document.addEventListener('DOMContentLoaded', () => {
    // console.log('Hamburger menu script loaded')

    // Toggle mobile menu visibility
    const hamburger = document.querySelector('.hamburger')
    const nav = document.querySelector('.site-header__nav')
    const mobileMenuClose = document.querySelector('.mobile-menu-close')
    const body = document.body
    const searchToggle = document.querySelector('.search-toggle')
    const searchPanel = document.querySelector('.search-panel')
    const mobileOpenHide = document.querySelector('[mobile-nav-closed]')

    // console.log('Found hamburger:', !!hamburger)
    // console.log('Found nav:', !!nav)
    // console.log('Found mobile close button:', !!mobileMenuClose)
    // console.log('Nav classes:', nav ? nav.className : 'nav not found')

    if (hamburger && nav) {
        hamburger.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
            // console.log('Hamburger clicked')
            toggleMobileMenu()
        })

        // Close mobile menu when clicking on nav links (except megamenu triggers)
        const navLinks = nav.querySelectorAll('a:not([data-mega-menu])')
        // console.log('Found navigation links:', navLinks.length)
        navLinks.forEach((link, index) => {
            // console.log(`Link ${index}:`, link.href, link.textContent.trim())

            // Use a different approach - listen for the navigation event
            link.addEventListener('click', function (e) {
                // console.log(
                //     'Link clicked:',
                //     link.href,
                //     'Window width:',
                //     window.innerWidth
                // )

                // Only handle on mobile
                if (window.innerWidth < 1024) {
                    // Check if it's a valid navigation link
                    if (
                        link.href &&
                        link.href !== '#' &&
                        !link.href.endsWith('#')
                    ) {
                        // console.log(
                        //     'Valid navigation link - closing menu after navigation'
                        // )
                        // Close menu with a small delay to ensure navigation happens first
                        setTimeout(() => {
                            closeMobileMenu()
                        }, 50)
                    }
                    // Don't prevent default - let the link navigate normally
                }
            })
        })

        // Close mobile menu when clicking outside
        document.addEventListener('click', function (e) {
            const isMenuOpen = body.classList.contains('menu-open')
            if (isMenuOpen && window.innerWidth < 1024) {
                const isClickInsideNav = nav.contains(e.target)
                const isClickOnHamburger = hamburger.contains(e.target)

                if (!isClickInsideNav && !isClickOnHamburger) {
                    closeMobileMenu()
                    // console.log('Menu closed via outside click')
                }
            }
        })

        // Close mobile menu when window is resized to desktop
        window.addEventListener('resize', function () {
            if (window.innerWidth >= 1024) {
                closeMobileMenu()
                // console.log('Menu closed via resize')
            }
        })

        // Handle sub-menu toggles on mobile
        const subNavTriggers = document.querySelectorAll('.sub-menu-trigger')
        subNavTriggers.forEach((trigger) => {
            trigger.addEventListener('click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                trigger.closest('li').classList.toggle('active')
                // console.log('Sub-menu toggled')
            })
        })
    }

    // Mobile close button
    if (mobileMenuClose) {
        mobileMenuClose.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
            // console.log('Close button clicked!')
            closeMobileMenu()
        })
    } else {
        console.warn('Mobile close button not found!')
    }

    // Search Bar functionality
    if (searchToggle && searchPanel) {
        // console.log('Setting up search functionality')

        // Toggle search bar visibility on search button click
        searchToggle.addEventListener('click', function (event) {
            event.preventDefault()
            event.stopPropagation()
            toggleSearchPanel()
        })

        // Hide search bar when clicking outside
        document.addEventListener('click', function (event) {
            const isClickInsideSearch =
                searchPanel && searchPanel.contains(event.target)
            const isClickOnSearchBtn = searchToggle.contains(event.target)
            const isClickOnCloseBtn =
                searchPanel && searchPanel.contains(event.target)

            if (
                (!isClickInsideSearch && !isClickOnSearchBtn) ||
                isClickOnCloseBtn
            ) {
                closeSearchPanel()
            }
        })

        // Close search when pressing Escape key
        document.addEventListener('keydown', function (event) {
            if (
                event.key === 'Escape' &&
                !searchPanel.classList.contains('hidden')
            ) {
                closeSearchPanel()
            }
        })
    }

    function toggleMobileMenu() {
        if (body.classList.contains('menu-open')) {
            closeMobileMenu()
        } else {
            openMobileMenu()
        }
    }

    function openMobileMenu() {
        body.classList.add('menu-open', 'no-scroll')
        // Show the mobile menu close button by removing hidden from its parent container
        if (mobileMenuClose && mobileMenuClose.parentElement) {
            mobileMenuClose.parentElement.classList.remove('hidden')
            mobileMenuClose.parentElement.classList.add('flex')
        }
        // Hide elements with mobile-nav-closed attribute when mobile nav is open
        const mobileOpenHideElements = document.querySelectorAll(
            '[mobile-nav-closed]'
        )
        mobileOpenHideElements.forEach((element) => {
            element.classList.add('hidden')
        })
        // console.log('Mobile menu opened')
        // console.log('Body classes after opening:', body.className)
        // console.log(
        //     'Nav display after opening:',
        //     window.getComputedStyle(nav).display
        // )
    }

    function closeMobileMenu() {
        body.classList.remove('menu-open', 'no-scroll')
        // Hide the mobile menu close button by hiding its parent container
        if (mobileMenuClose && mobileMenuClose.parentElement) {
            mobileMenuClose.parentElement.classList.add('hidden')
            mobileMenuClose.parentElement.classList.remove('flex')
        }
        // Show elements with mobile-nav-closed attribute when mobile nav is closed
        const mobileOpenHideElements = document.querySelectorAll(
            '[mobile-nav-closed]'
        )
        mobileOpenHideElements.forEach((element) => {
            element.classList.remove('hidden')
        })
        // console.log('Mobile menu closed')
        // console.log('Body classes after closing:', body.className)
    }

    function toggleSearchPanel() {
        if (searchPanel.classList.contains('hidden')) {
            openSearchPanel()
        } else {
            closeSearchPanel()
        }
    }

    function openSearchPanel() {
        searchPanel.classList.remove('hidden')
        // Show overlay when search panel opens
        if (window.MainOverlay) {
            window.MainOverlay.show()
        }
        // Focus on search input if it exists
        const searchInput = searchPanel.querySelector(
            'input[type="search"], input[name="q"]'
        )
        if (searchInput) {
            setTimeout(() => searchInput.focus(), 100)
        }
    }

    function closeSearchPanel() {
        searchPanel.classList.add('hidden')
        // Hide overlay when search panel closes
        if (window.MainOverlay) {
            window.MainOverlay.hide()
        }
        // Clear the search input when closing
        const searchInput = searchPanel.querySelector(
            'input[type="search"], input[name="q"]'
        )
        if (searchInput) {
            searchInput.value = ''
        }
    }
})
